"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingMessagesList = void 0;
var React = require("react");
var BookingMessageDisplay_1 = require("./BookingMessageDisplay");
var moment = require("moment");
var config_1 = require("../../../config");
var BookingMessageForm_1 = require("./BookingMessageForm");
function BookingMessagesList(_a) {
    var user = _a.user, booking = _a.booking, show_new = _a.show_new, cancel_new = _a.cancel_new, messages = _a.messages, bookingMessageSvc = _a.bookingMessageSvc;
    if (!booking)
        return (React.createElement("div", { className: "container", style: { height: "calc(100vh - 240px)" } },
            React.createElement("div", { className: "row align-items-center h-100" },
                React.createElement("div", { className: "col-6 mx-auto" },
                    React.createElement("div", null, gettext("Please select a booking"))))));
    if ((!messages || messages.length == 0) && !show_new)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row" },
            React.createElement("h5", { className: "mt-2" }, gettext("Booking Messages"))),
        React.createElement("div", { style: { height: "calc(100vh - 280px)", overflowY: "auto" } },
            show_new && (React.createElement("div", { className: "row logistics-message" },
                React.createElement("div", { className: "col-7 logistics-message-author" },
                    React.createElement("p", null, user.full_name + " (" + user.company + ")")),
                React.createElement("div", { className: "col-5 logistics-message-date" },
                    React.createElement("p", null, moment().format(config_1.ISO_DATETIME_FORMAT))),
                React.createElement("div", { className: "col logistics-message-body-new" },
                    React.createElement(BookingMessageForm_1.BookingMessageForm, { booking: booking, user: user, bookingMessageSvc: bookingMessageSvc, cancel_new: cancel_new })))),
            messages.map(function (message) {
                return (React.createElement(BookingMessageDisplay_1.BookingMessageDisplay, { message: message, key: message.id }));
            }))));
}
exports.BookingMessagesList = BookingMessagesList;
